
import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { useInternalAuth } from './useInternalAuth';

export const useAuthenticatedUser = () => {
  const { user: supabaseUser, profile } = useAuth();
  const { user: internalUser } = useInternalAuth();

  // Memoize to prevent reference changes on each render
  const user = useMemo(() => {
    return supabaseUser || internalUser || null;
  }, [supabaseUser, internalUser]);

  return {
    user,
    supabaseUser,
    internalUser,
    profile
  };
};
